import React from "react";
import { Stepper, Step } from "@progress/kendo-react-layout";
import "./stepper.pure.css";

const CustomStepItem = (props) => {
  const { image, icon } = props;

  let content = <span className="stepperPure-index">{props.index}</span>
  if (image) {
    content = <img className="stepperPure-image" src={image} alt={props.title || "Step icon"} />;
  } else if (icon) {
    content = <span className={`stepperPure-icon k-icon k-font-icon ${icon}`}></span>
  }

  return (
    <Step {...props}>
      <span className="k-step-indicator">
        {content}
      </span>
    </Step>
  );
};

const StepperPure = (props) => {
  return (
    <Stepper
      item={CustomStepItem}
      {...props}
      className={`stepperPure ${props.className}`}
    />
  );
};

export default StepperPure;

// k-icon k-font-icon 